import type {LoginCredentials} from '../repository/AuthRepository';
import type {AuthRepository} from '../repository/AuthRepository';
import type {User} from '../models/User';

export class LoginUseCase {
  constructor (private authRepository: AuthRepository) {}

  async execute (credentials: LoginCredentials): Promise<{ success: boolean; user?: User; message?: string; error?: string }> {
    try {
      const result = await this.authRepository.login(credentials);
      return {
        success: true,
        user: result.user,
        message: result.message
      };
    } catch (error) {
      // تمرير رسالة الخطأ الأصلية من الخادم
      let errorMessage = 'حدث خطأ غير متوقع';
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      return {
        success: false,
        error: errorMessage
      };
    }
  }
}
